import React, { FC, ReactNode, useCallback, useState } from 'react';
import cn from 'classnames';
import SimpleBar from 'simplebar-react';

import { useCallbackRef } from '../../hooks';
import { CloseButton } from '.';

interface Props {
  className?: string;
  childClassName?: string;
  header: React.ReactNode;
  footer?: React.ReactNode;
  children?: ReactNode;
  onClose(): void;
}

const ScrollableView: FC<Props> = ({
  children,
  childClassName,
  className,
  header,
  footer,
  onClose,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  const scrollShadowCallback = useCallback((node: HTMLDivElement) => {
    const handleScroll = () => setIsScrolled(node.scrollTop > 0);
    node.addEventListener('scroll', handleScroll);

    return () => node.removeEventListener('scroll', handleScroll);
  }, []);

  const refElement = useCallbackRef(scrollShadowCallback);

  return (
    <div className={className}>
      <CloseButton onClick={() => onClose()} />
      <div className={cn('Header', isScrolled && ' shadow')}>{header}</div>
      <section className={cn('pb-none', childClassName)}>
        <SimpleBar
          autoHide={false}
          className="h-full"
          scrollableNodeProps={{ ref: refElement }}
        >
          {children}
        </SimpleBar>
      </section>
      {footer}
    </div>
  );
};

export default ScrollableView;
